// NOTE: esbuild移行の一環として、基本的に過去の仕様をそのままコピペしている
// ページのスクロール位置に応じてサイドバーのリンクをハイライトし、現在のセクションを示す。
// (すなわち、スクロールスパイのカスタム実装、目次の高さもウィンドウに合わせて調整)
// スクロール関連のロジックを関数にまとめるなど可読性向上が推奨される。

function initializeSidebarScrollSpy() {
  const navLink = $(".usersContentRight li.userSideMenu a");
  if (!navLink[0]) {
    return false;
  }
  // 見出しを配列に格納
  const contentsArr = navLink
    .map(function () {
      return $($(this).attr("href"));
    })
    .get();

  // ページ読み込み時とスクロール時に、現在地をチェックする
  $(window).on("load scroll", () => {
    navLink.removeClass("current");
    // 現在のスクロール位置を取得
    const windowScrolltop = $(window).scrollTop() + 50;
    for (let i = 0; i < contentsArr.length; i += 1) {
      // DOM上にサイドバーの見出しからリンクされる要素がない場合
      if (contentsArr[i].length === 0) continue;
      // DOM上にサイドバーのクリックされた見出しの「次の見出し」からリンクされる要素がない場合
      const isLinkedNextElmExists =
        contentsArr[i + 1] && contentsArr[i + 1].length > 0;
      // 現在のスクロール位置が、見出しと次の見出しの間にあるものを調べる
      let isCorrectNavigation;
      if (i < contentsArr.length - 1 && isLinkedNextElmExists) {
        isCorrectNavigation =
          contentsArr[i].offset().top <= windowScrolltop &&
          contentsArr[i + 1].offset().top > windowScrolltop;
      } else if (i === contentsArr.length - 1) {
        isCorrectNavigation = contentsArr[i].offset().top <= windowScrolltop;
      }
      if (isCorrectNavigation) {
        // ナビゲーションにclass="current"をつける
        navLink.eq(i).addClass("current");
        // 社会課題の子要素にcurrent付いている時には親にも付けたままにする
        if (navLink.eq(i).parent().hasClass("userSideMenuChild")) {
          $(".usersContentRight li.userSideMenuParent a").addClass("current");
        }

        // 目次のカレントが表示領域から出たら見える位置までスクロール
        const tocList = $(".toc_widget>ul.toc_list");
        const posTop = navLink.eq(i).position().top;
        if (tocList.innerHeight() < posTop + 60) {
          tocList.scrollTop(
            tocList.scrollTop() - tocList.innerHeight() + posTop + 60
          );
        }
        if (posTop < 60) {
          tocList.scrollTop(tocList.scrollTop() - 60);
        }
        break;
      }
    }
  });
  // ページ読み込み時とリサイズ時に目次のMaxHeightを設定
  let timer = false;
  $(window).on("load resize", () => {
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      $(".toc_widget>ul.toc_list").css("max-height", $(window).height() - 100);
    }, 100);
  });
}

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export default initializeSidebarScrollSpy;